// src/features/team/RolePicker.tsx
// Popover-listbox picker over a team's roles — replaces raw "paste a role ID"
// text fields in schedule/delegation dialogs with a real picker.

import { useEffect, useState } from 'react';
import { useI18n } from '@react/hooks';
import { useTeam } from '@react/hooks';
import { Select } from '@/components/Select';
import { getEntityId } from './logic';

export interface RolePickerProps {
  teamId: string;
  value: string;
  onChange: (roleId: string) => void;
  className?: string;
}

export function RolePicker({ teamId, value, onChange, className }: RolePickerProps) {
  const { t } = useI18n();
  const store = useTeam();
  const [roles, setRoles] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    if (!teamId) return;
    let cancelled = false;
    store.ListTeamRoles(teamId).then((res: any) => {
      if (cancelled) return;
      const list = res?.roles?.roles ?? res?.roles ?? [];
      setRoles((Array.isArray(list) ? list : []).map((r: any) => ({ id: getEntityId(r), name: r.name || getEntityId(r) })));
    }).catch(() => {});
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teamId]);

  return (
    <Select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      options={roles.map((r) => ({ value: r.id, label: r.name }))}
      placeholder={t('team.roleField.namePlaceholder')}
      aria-label={t('common.role')}
      fullWidth={false}
      className={className}
    />
  );
}

export default RolePicker;
